// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_full_screen-module__overlay--26PTz","container":"modal_full_screen-module__container--1ql_x","noBodyScroll":"modal_full_screen-module__noBodyScroll--L_P8Y"};